import giveTranslation from '../give-translations';

const fn = {
  classCommentHidden: 'card__comment--hidden',
  init: () => {
    const showMoreLinks = document.querySelectorAll('.js-comments-show-more');

    if (!showMoreLinks.length) {
      return;
    }

    [].forEach.call(showMoreLinks, (showMoreLink) => {
      const commentsCount = showMoreLink.parentNode.querySelector('.js-comments-count');

      fn.initCommentsCount(commentsCount);

      showMoreLink.addEventListener('click', (e) => {
        e.preventDefault();

        fn.showMoreComments(showMoreLink.getAttribute('data-comments-more-message-id'));
        fn.increaseCommentsCount(commentsCount, showMoreLink, 3);
      });
    });
  },
  initCommentsCount: (commentsCountElement) => {
    const commentsCurrentCount = commentsCountElement.getAttribute('data-comments-current') * 1;
    const commentsTotalCount = commentsCountElement.getAttribute('data-comments-length') * 1;

    if (!commentsCurrentCount || !commentsTotalCount) {
      return;
    }

    if (commentsCurrentCount > commentsTotalCount) {
      commentsCountElement.innerHTML = `${commentsTotalCount} ${giveTranslation('api.comments.from')} ${commentsTotalCount}`;
    }
  },
  increaseCommentsCount: (commentsCountElement, showMoreLinkElement, commentsCountIncrease) => {
    const commentsCurrentCount = commentsCountElement.getAttribute('data-comments-current') * 1;
    const commentsTotalCount = commentsCountElement.getAttribute('data-comments-length') * 1;

    if (!commentsCurrentCount || !commentsTotalCount) {
      return;
    }

    const commentsCount = commentsCurrentCount + commentsCountIncrease;

    if (commentsCount <= commentsTotalCount) {
      commentsCountElement.innerHTML = `${commentsCount} ${giveTranslation('api.comments.from')} ${commentsTotalCount}`;
      commentsCountElement.setAttribute('data-comments-current', commentsCount);

      if (commentsCount === commentsTotalCount) {
        showMoreLinkElement.innerHTML = '';
      }
    } else {
      commentsCountElement.innerHTML = `${commentsTotalCount} ${giveTranslation('api.comments.from')} ${commentsTotalCount}`;
      commentsCountElement.setAttribute('data-comments-current', commentsTotalCount);
      showMoreLinkElement.innerHTML = '';
    }
  },
  showMoreComments: (commentsMessageId) => {
    if (!commentsMessageId) {
      return;
    }

    const commentsMessage = document.querySelector(`[data-comments-message-id="${commentsMessageId}"]`);

    if (!commentsMessage) {
      return;
    }

    const comments = commentsMessage.querySelectorAll('.card__comment');
    let visibleComments = 0;

    [].forEach.call(comments, (comment) => {
      if (!comment.classList.contains(fn.classCommentHidden) || visibleComments >= 3) {
        return;
      }

      comment.classList.remove(fn.classCommentHidden);
      visibleComments += 1;
    });

    app.msnry.inst.layout();
  },
};

export default fn;
